"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
const typedi_1 = require("typedi");
const mitt_1 = __importDefault(require("mitt"));
/**
 * Event emitter
 */
let EventEmitter = class EventEmitter {
    constructor() {
        this.emitter = (0, mitt_1.default)();
    }
    /**
     * Регистрирует обработчик
     */
    on(type, handler) {
        this.emitter.on(type, handler);
    }
    /**
     * Удаляет обработчик
     */
    off(type, handler) {
        this.emitter.off(type, handler);
    }
    /**
     * Создает событие
     */
    emit(type, data) {
        this.emitter.emit(type, data);
    }
};
EventEmitter = __decorate([
    (0, typedi_1.Service)()
], EventEmitter);
exports.EventEmitter = EventEmitter;
